import React from 'react';

export type BadgeColor = 'red' | 'yellow' | 'green' | 'blue' | 'indigo' | 'purple' | 'pink' | 'gray';

export interface StatusBadgeProps {
  label: string;
  color?: BadgeColor;
  className?: string;
}

export default function StatusBadge({
  label,
  color = 'gray',
  className = ''
}: StatusBadgeProps) {
  const getDotColorClass = (color: BadgeColor) => {
    switch (color) {
      case 'red':
        return 'fill-red-500';
      case 'yellow':
        return 'fill-yellow-500';
      case 'green':
        return 'fill-green-500';
      case 'blue':
        return 'fill-blue-500';
      case 'indigo':
        return 'fill-indigo-500';
      case 'purple':
        return 'fill-purple-500';
      case 'pink':
        return 'fill-pink-500';
      case 'gray':
      default:
        return 'fill-gray-500';
    }
  };

  return (
    <span className={`inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 dark:text-white ring-1 ring-inset ring-gray-200 dark:ring-gray-700 ${className}`}>
      <svg viewBox="0 0 6 6" aria-hidden="true" className={`h-1.5 w-1.5 ${getDotColorClass(color)}`}>
        <circle r="3" cx="3" cy="3" />
      </svg>
      {label}
    </span>
  );
}
